import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function NewsSection() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              赛事资讯
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              最新动态与攻略
            </h2>
          </div>
          <Link
            to="/category/news"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors no-underline cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200 rounded-2xl overflow-hidden hover:border-primary-200 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 17.cn一起草每日大赛`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-primary-600 font-medium bg-primary-50 px-2.5 py-1 rounded-full">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}